export const validationMessages = {
  'generic-required': ' Field is required',
  'name-required': 'Please enter your full name',
  'name-pattern':'Name is not valid! It must not contain numbers   or special characters', 
  'phone-pattern': 'Please enter correct Phone number',
  'pincode-pattern': 'Please enter correct pin code',
  'generic-pattern':  'Pattern does not match',
  'userData-required': 'Please enter your full name',
  'userData-pattern': 'Only alphabets are allowed',
  'email-required': 'Please enter email address',
  'email-pattern': 'Please enter correct email id',
  'password-required': 'Please enter Password',
  'country-required': 'Select a value from dropdown',
  'address-required': 'Please enter complete postal address',
  'address-pattern': 'Only Alpha-Numeric values and characters like `_ . / &` are allowed',
  'checkboxes-required': 'Please select both options',
  'gender-required': 'Please select one option',
  'pan-pattern':'Enter valid pan card number', 
  'customer-pattern': 'Only charchter allowed!!',
};
